import { useSelector, useDispatch } from 'react-redux';
import { getMatrices, initializeAuth, getMatrixData } from "../../services/apiService";
import { setMatrices, setMatricesData } from '../../redux/rulesSlice';
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from 'react';
import Select from 'react-select';

export const MatrixList = () => {
  const { instance, accounts } = useMsal();
  const { matrices, dbSrc } = useSelector(state => state.rules);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchMatrices = async () => {
      if (matrices.length === 0) {
        await initializeAuth(instance, accounts);
        const matricesData = await getMatrices();
        console.log("Matrices:", matricesData);
        dispatch(setMatrices(matricesData));

      }
    };

    fetchMatrices();
  }, [matrices.length]);

  useEffect(() => {
    const resetMatrixList = async () => {
        dispatch(setMatricesData([]));
        dispatch(setMatrices([]));
        await initializeAuth(instance, accounts);
        const matricesData = await getMatrices();
        console.log("Matrices:", matricesData);
        dispatch(setMatrices(matricesData));
    };

    resetMatrixList();
  }, [dbSrc]);


  const handleMatricesData = async (matrix) => {
    await initializeAuth(instance, accounts);
    const matricesData = await getMatrixData(matrix);
    console.log("Matrix Data:", matricesData);
    dispatch(setMatricesData(matricesData));
  };

  const options = matrices.map(item => {
      return {
        value: item,
        label: item,
      };
    });

  return (
    <>
      {matrices.length > 0 ? (
        <Select options={options}
          isSearchable
          select onChange={(e) => handleMatricesData(e.value) }
         />
      ) : (
       <p>Loading...</p>
      )}
    </>
  );
};
